import { ReactComponent as CloseIcon } from '@assets/icons/close.svg';

import {
  Box,
  Flex,
  Grid,
  GridItem,
  Stack,
  Text,
  useTheme
} from '@chakra-ui/react';

//  Not used anywhere ..
//  import { formatCurrency } from 'utils';
import { DiscountCode } from 'types';

interface DiscountItemProps {
  onRemoveDiscount: (() => void) | null;
  promoData: DiscountCode;
  promoCode: string;
}
//  No more support for percentage discount
//  discountValue: number;

const DiscountItem = ({
  promoData,
  onRemoveDiscount = null,
  promoCode
}: DiscountItemProps) => {
  const {
    colors: {
      palette: {
        booking: {
          stepReview: {
            reservationList: { discountItem }
          }
        }
      }
    }
  } = useTheme();

  return (
    <Grid
      templateColumns='repeat(10, 1fr)'
      px={{ base: '15px', md: '30px' }}
      py={{ base: '15px', md: '20px' }}
      columnGap='20px'
      bg={discountItem.background}
    >
      <GridItem colSpan={10}>
        <Flex>
          {onRemoveDiscount !== null && (
            <Box
              w='16px'
              h='40px'
              mr='20px'
              p={0}
              onClick={onRemoveDiscount}
              alignContent='center'
            >
              <CloseIcon
                width={16}
                height={25}
                fill={discountItem.closeIconFill}
              />
            </Box>
          )}
          <Stack h='100%' alignItems='start' justifyContent='start' gap='3px'>
            <Text
              fontSize='12px'
              color={discountItem.discountTextColor}
              lineHeight='130%'
              textTransform='uppercase'
            >
              Promo Code
            </Text>
            <Text
              fontSize='18px'
              color={discountItem.discountTextColor}
              textTransform='uppercase'
            >
              {promoData?.name || promoCode}
            </Text>
          </Stack>
        </Flex>
      </GridItem>
    </Grid>
  );
};

export default DiscountItem;
